<template lang="html">
  <div class="page-wrapper">
    <div class="container">
      <BaseLoading  :spinning="athletesLoading" size="large">
        <!-- content -->
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <!-- search-content -->
              <div class="container search-content">
                <h2>Search for Players</h2>
              </div>
              <div class="dynamic-search-container-athlete">
                <div class="mobile-filter">
                  <div class="filter-button" @click="showDrawer">
                    <a-icon type="filter" />
                    Filter Table
                  </div>
                  <a-drawer
                    class="filter-modal menu-modal custom-modal"
                    placement="right"
                    :visible="visible"
                    @close="onClose"
                  >
                    <div class="filter-title">
                      Filter Player Search
                    </div>
                    <BaseFilter
                      class="collapse in"
                      :config="searchConfig"
                      @on-filter-change="handleFilterChange"
                      @submit="handleFilterApply"
                    />
                  </a-drawer>
                </div>
                <BaseFilter
                  class="collapse in"
                  :config="searchConfig"
                  @on-filter-change="handleFilterChange"
                  @submit="handleFilterApply"
                />
              </div>
              <BaseTable
                class="margin-t-1"
                :columns="columns"
                :data="athletes"
                :pagination="paginationOptions"
                @change="handleTableChange"
                :loading="athletesLoading"
                :show-zero="athleteMeta.total === 0"
              />
            </div>
          </div>
        </div>
      </BaseLoading>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Athlete } from "@/models";
import { ATHLETE_INDEX_TABLE_COLUMNS } from "@/utils/columns";
import generateImageUrl from "@/utils/generate-image-url";

const ATHLETE_STORE_KEY = "athleteStore";
const FAVOURITE_STORE_KEY = "favouriteStore";
const AthleteFields =
  "athletename, profileImage, profileType, state, city, graduationYear, birthYear, birthMonth, birthDay, battingHand, battingAverage, throwingHand, videoFlag, division, gpa, committed";

export default {
  mounted() {
    this.dispatcher();
  },
  data() {
    return {
      paginationLimit: 40,
      searchQuery: {},
      visible: false,
      currentPage: 1
    };
  },
  computed: {
    searchConfig() {
      return this.yearsRemanindAdded
        ? [...Athlete.searchConfig(), Athlete.yearsRemaningConfig]
        : Athlete.searchConfig();
    },
    yearsRemanindAdded() {
      return this.searchQuery["graduationYear"] === "College Transfer";
    },
    columns() {
      return [
        {
          title: "Fav",
          dataIndex: "favourite",
          customRender: (_text, rowData) => {
            const h = this.$createElement;
            const className = rowData.favC ? "icon-filled" : "";
            const iconTheme = rowData.favC ? "filled" : "outlined";
            return (
              <BaseButton
                type="link"
                class={className}
                on-click={event => this.handleFavouriteClick(event, rowData)}
              >
                <BaseIcon type="star" theme={iconTheme} />
              </BaseButton>
            );
          }
        },
        {
          title: "Name",
          dataIndex: "athleteName",
          customRender: (_text, rowData) => {
            const h = this.$createElement;
            return (
              <a
                href={this.hrefRoute(rowData.id, rowData.profileType)}
                class="text-black d-flex align-center"
                // target="_blank"
                on-click={() => this.hrefRoute(rowData.id, rowData.status)}
              >
                <BaseImageWrapper
                  class="margin-r-10"
                  size={45}
                  imageUrl={generateImageUrl(rowData.profileImage)}
                  wrapperStyle="circle"
                  name={rowData.athleteName}
                />
                {rowData.athleteName}
              </a>
            );
          }
        },
        ...ATHLETE_INDEX_TABLE_COLUMNS,
        {
          title: "Committed to College",
          dataIndex: "committed",
          customRender: (_text, rowData) => {
            const h = this.$createElement;
            return rowData.committed ? <span>YES</span> : <span>NO</span>;
          }
        }
      ];
    },
    paginationOptions() {
      return {
        total: this.athleteMeta.total ||40,
        current: this.currentPage || 1,
        simple: true,
        pageSize: 40
      };
    },
    ...mapGetters({
      athletes: `${ATHLETE_STORE_KEY}/athletes`,
      athleteMeta: `${ATHLETE_STORE_KEY}/athleteMeta`,
      athletesLoading: `${ATHLETE_STORE_KEY}/athletesLoading`
    })
  },
  methods: {
    handleTableChange(pagination) {
      this.dispatcher(pagination.current);
    },
    handleFilterChange(searchFilters) {
      this.searchQuery = searchFilters;
      this.searchQuery = this.yearsRemanindAdded
        ? this.searchQuery
        : { ...this.searchQuery, yearsRemaning: null };
      this.searchQuery = this.searchQuery["position"]
        ? {
            ...this.searchQuery,
            position: this.searchQuery["position"].join(",") || null
          }
        : { ...this.searchQuery, position: null };
    },
    dispatcher(page = 1) {
      this.currentPage = page;
      if (this.onlyClubCoach()) {
        this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthletesForClubCoach`, {
          fields: AthleteFields,
          limit: this.paginationLimit,
          page: this.currentPage,
          ...this.searchQuery
        });
        return;
      }
      this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthletes`, {
        fields: AthleteFields,
        limit: this.paginationLimit,
        page: this.currentPage,
        ...this.searchQuery
      });
    },

    async handleFavourite(rowData){
        if (rowData.favC) {
          await this.$store.dispatch(`${FAVOURITE_STORE_KEY}/deleteFavourite`, {
            favBy: Athlete.profileId(),
            favTo: rowData.Id
          });
          this.$store.dispatch(`${ATHLETE_STORE_KEY}/unsetFavourite`, rowData.Id);
          return;
        }
      await this.$store.dispatch(`${FAVOURITE_STORE_KEY}/createFavourite`, {
        favBy: Athlete.profileId(),
        favTo: rowData.Id,
        typeFav: "athlete"
      });
      this.$store.dispatch(`${ATHLETE_STORE_KEY}/setFavourite`, rowData.Id);

    },
    async handleFavouriteClick(event, rowData) {
      event.stopImmediatePropagation();
      const local_profile_id = localStorage.getItem("profile-id");
      const route_profile_id = this.$route.params.profileId;
      const currentUser = localStorage.getItem("user-permissions");
      if(currentUser === '"player"'){
        this.handleFavourite(rowData);
      }else{
        if(local_profile_id === route_profile_id){
          this.handleFavourite(rowData);
        }else{
           this.$notification.error({
              message: "Error",
              description:"Favourite Error"
            });
        }
      }
    },
    
    hrefRoute(athleteId, profileType) {
      return profileType === "Basic"
        ? `/${Athlete.profileId()}/athlete/${athleteId}/public_view`
        : `/${Athlete.profileId()}/athlete/${athleteId}/summary`;
    },
    handleFilterApply() {
      this.visible = false;
      this.dispatcher();
    },

    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    handleOk(e) {
      this.visible = false;
    }
  }
};
</script>

<style lang="sass">
.dynamic-search-container-athlete
  .filter-button
    display: none
    justify-content: center
    align-items: center
    width: 100%
    margin: 0 auto 20px
    border: 1px solid #b0b0b0
    border-radius: 3px
    padding: 8px 30px
    color: #4a4a4a
    font-weight: 500
    font-size: 15px
    .anticon
      margin-right: 8px
  form
    display: grid
    grid-template-columns: repeat(12, 1fr)
    .ant-form-item
      margin-bottom: 5px
    .grid-component
      padding-right: 10px
    .grid-component-wrapper-one
      grid-column-start: 1
      grid-row-start: 1
      grid-column-end: 3
      width: 95%
    .grid-component-wrapper-two
      grid-column-start: 3
      grid-column-end: 5
      grid-row-start: 1
      width: 95%
    .grid-component-wrapper-three
      grid-column-start: 5
      grid-column-end: 7
      grid-row-start: 1
    .grid-component-wrapper-four
      grid-column-start: 7
      grid-column-end: 9
      grid-row-start: 1
    .grid-component-wrapper-five
      grid-column-start: 9
      grid-row-start: 1
      grid-column-end: 11
    .grid-component-wrapper-six
      grid-column-start: 11
      grid-column-end: 13
      grid-row-start: 1
    .grid-component-wrapper-seven
      grid-row-start: 2
      width: 80%
      margin-top: 4px
      margin-left: 2rem
      grid-column-start: 1
      grid-column-end: 3
    .grid-component-wrapper-eight
      grid-row-start: 2
      grid-column-start: 3
      grid-column-end: 5
      margin-top: 4px
      width: 95%
    .grid-component-wrapper-nine
      grid-row-start: 2
      grid-column-start: 5
      grid-column-end: 7
      margin-top: 4px
      width: 95%
    .grid-component-wrapper-ten
      grid-row-start: 2
      grid-column-start: 7
      grid-column-end: 9
      margin-top: 5px
    .grid-component-wrapper-eleven
      grid-row-start: 2
      grid-column-start: 9
      grid-column-end: 11
      margin-top: 5px !important
    .grid-component-wrapper-twelve
      grid-row-start: 2
      grid-column-start: 11
      grid-column-end: 12
    .grid-component-wrapper-thirteen
      grid-row-start: 3
      grid-column-start: 5
      grid-column-end: 7
    .grid-component-wrapper-fourteen
      grid-row-start: 3
      grid-column-start: 7
      grid-column-end: 9
    .grid-component-wrapper-fifteen
      grid-row-start: 4
      grid-column-start: 6
      grid-column-end: 8
      align-self: center

@media only screen and (max-width: 575px)
  .dynamic-search-container-athlete
    .filter-button
      display: flex
    form
      display: none !important
</style>
